module.exports = __webpack_public_path__ + "img/2700f.0d357a20.png";